import { render } from "./SolveWay.vue?vue&type=template&id=0fa33024"
import script from "./SolveWay.vue?vue&type=script&lang=js"
export * from "./SolveWay.vue?vue&type=script&lang=js"

import "./SolveWay.vue?vue&type=style&index=0&id=0fa33024&lang=scss"

import exportComponent from "D:\\xampp\\htdocs\\JuHui\\ju-hui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__